import React from 'react';
import { useSelector } from 'react-redux';

import useOptimizerEditorVersions from '../../hooks/optimizer/useOptimizerEditorVersions';
import EditorVersionHistory from '../buttons/EditorVersionHistory';

import { editorTypes } from '../../constants/tiptapEditorConstants';

import { selectAIStateLoading } from '../../store/tiptapEditor.selectors';

const OptimizerVersionHistory = () => {
    const aiLoading = useSelector(selectAIStateLoading);

    const {
        createNewEditorVersion,
        isVersionCreating,
        handleActivateEditorVersion,
        handlePreviewEditorVersion,
        handleUpdateVersionName,
        handleDeleteEditorVersion,
    } = useOptimizerEditorVersions();

    return (
        <EditorVersionHistory
            disabled={aiLoading}
            editorType={editorTypes.OPTIMIZER}
            createNewEditorVersion={createNewEditorVersion}
            newEditorVersionCreating={isVersionCreating}
            handleActivateEditorVersion={handleActivateEditorVersion}
            handlePreviewEditorVersion={handlePreviewEditorVersion}
            handleUpdateVersionName={handleUpdateVersionName}
            handleDeleteEditorVersion={handleDeleteEditorVersion}
        />
    );
};

export default OptimizerVersionHistory;
